
import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import SelectPulldown from '@/components/molecules/SelectPulldown.vue'
import { ProgressFilter } from '@/const/ProgressFilter'
import { SelectItem } from '@/models/SelectItem'

/**
 * 学習進捗絞り込みプルダウンメニュー
 */
@Component({
  components: {
    SelectPulldown,
    ImageBase,
    ButtonBase,
  },
})
export default class ProgressFilterPulldown extends Vue {
  /** プルダウンセレクト分子 */
  @Ref()
  selectPulldown!: SelectPulldown

  /** 初期値の学習進捗絞り込みコード */
  @Prop()
  private defaultProgressFilterCode!: string

  /** ボタンのラベル */
  private labelButton: string = ''

  /**
   * 学習進捗絞り込みマスタをSelectItem型に変換
   *
   * @returns 学習進捗の配列（SelectItem型）
   */
  private get selectOptions(): SelectItem[] {
    const list: SelectItem[] = []
    ProgressFilter.LIST.forEach((status) => {
      list.push({ value: status.code, label: status.label })
    })
    return list
  }

  /**
   * 選択中の学習状況を取得
   *
   * @returns 選択中の学習状況コード
   */
  public selectedValue(): string {
    return this.selectPulldown.selectedValue()
  }

  /**
   * 初期処理
   */
  private mounted(): void {
    this.setButtonLabel()
  }

  /**
   * 値が変更を親コンポーネントに通知、ラベルを更新する
   */
  private changeEvent(): void {
    this.setButtonLabel()
    this.$emit('change', event)
  }

  /**
   * ボタンのラベルを設定
   */
  private setButtonLabel(): void {
    this.labelButton = this.selectPulldown.getOptionLabel()
  }
}
